export default __webpack_public_path__ + "static/media/ava-11.1be8842a.png";